import actionPrefix from '../../utils/actionPrefix';

const prefix = actionPrefix('trendingCorridorDestinations');

// Actions
const FETCH_REQUEST = prefix('FETCH_REQUEST');
const FETCH_ERROR = prefix('FETCH_ERROR');
const FETCH_SUCCESS = prefix('FETCH_SUCCESS');

// Reducer handlers
const reducerHandlers = {
  [FETCH_SUCCESS](state, { payload }) {
    return {
      ...state,
      trending: payload
    };
  }
};

// Action creators
const request = () => ({
  type: FETCH_REQUEST
});

const throwError = payload => ({
  type: FETCH_ERROR,
  payload
});

const success = payload => ({
  type: FETCH_SUCCESS,
  payload
});

// Effects
export const fetchTrendingCorridorDestinations = (queryString = '') => (dispatch) => {
  dispatch(request());
  return fetch(`/node/home/trending-corridor-destinations${queryString}`, {
    method: 'GET',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then((res) => {
    if (res.ok) {
      res.json().then(data => dispatch(success(data)));
    }
  }).catch((err) => {
    dispatch(throwError(err));
  });
};

export default reducerHandlers;

